<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.375 11.625H4.17188L10.0312 5.76562L9.23438 4.96875L3.375 10.8281V11.625ZM2.25 12.75V10.3594L10.8281 1.78125L13.2188 4.17188L4.64062 12.75H2.25ZM9.62578 5.37422L9.23438 4.96875L10.0312 5.76562L9.62578 5.37422Z" fill="#EC0E00"/>
</svg>
